export const hasClosedDevices = (group) => {
  return group.devices.some((device) => {
    return device.status !== 0;
  });
}
